<template>
<!--    <v-modal-slot id="change-expedient-media-name-modal"
                  @accepted="acceptModal">
        <template v-slot:modal-title>
            {{ name }}
        </template>

        <template v-slot:modal-content>
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label class="form-label">Nombre: </label>
                        <input type="text" class="form-control" aria-label="Nombre" v-model="written_name"/>
                    </div>
                </div>
            </div>
        </template>

        <template v-slot:accept-button>
            Guardar
        </template>

        <template v-slot:close-button>
            Cerrar
        </template>

    </v-modal-slot>-->



    <v-modal-validated :title="name"
                       accept-button-text="Guardar"
                       close-button-text="Cerrar"
                       :rules="rules"
                       id="change-expedient-media-name-modal"
                       @closed="closeModal"
                       @accepted="acceptModal">

        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label class="form-label">Nombre: </label>
                    <Field type="text" name="name" class="form-control" aria-label="Nombre" v-model="written_name"/>

                    <ErrorMessage name="name"/>
                </div>
            </div>
        </div>
    </v-modal-validated>


</template>

<script>

import VModalValidated from "../../../general/VModalValidated";
import {setMediaName} from "../../../../helpers/requests/RequestsMedia";
import {ErrorMessage, Field, Form} from "vee-validate";
import * as yup from "yup";

export default {
    name: "ExpedientDetailChangeMediaName",
    components: {VModalValidated, Form, Field, ErrorMessage},
    data() {
        const rules = yup.object({
            name: yup.string().required('Debes incluir un nombre'),
        });

        return {
            written_name: '',
            rules
        }
    },
    props: {
        fileId: {
            type: Number,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        expedientId: {
            type: Number,
            required: true,
        }
    },
    mounted() {
        this.written_name = this.name;
    },
    methods: {
        async acceptModal() {
            if (this.written_name !== null && this.written_name !== "") {
                await setMediaName(this.expedientId, this.fileId, this.written_name);
                this.$store.dispatch('app/setToastMessage', 'Nombre del fichero cambiado con éxito');

                this.$emit('name-changed');
            }
        },
        closeModal() {
            this.$emit('closed');
        }
    },
}
</script>
